// ============================================
// P3 支付线（F-08）：素材库 API（dtwin-server /material/*）
// ============================================
import client from './client';

export interface MaterialItem {
  id: string;
  sourceId: string;
  name: string;
  coverImageUrl: string;
  desc?: string | null;
  categoryTags?: string[] | null;
  priceType: 'free' | 'paid';
  packageId?: string | null;
  /** 单购价格（元）；null=无单购价（仅套餐权益） */
  price?: number | null;
  watermark: boolean;
  assetType: string;
  entitled: boolean;
  locked: boolean;
  /** 未授权时为空（服务端不下发真实地址） */
  downloadUrl: string;
}

export async function fetchMaterialList(): Promise<{ list: MaterialItem[] }> {
  const { data } = await client.get('/material/list');
  return data;
}
